import React, { useEffect, useRef } from 'react';

import { usePreviousValue } from '../../../../../../../common/hooks/usePreviousValue';

import { RefButtonHelper } from '../../../../../../../helpers/buttons/RefButtonHelper';
import { Icon } from '../../../../../../../helpers/Icon';
import { Translate } from '../../../../../../../helpers/Translate';

import { IconsEnum } from '../../../../../../../assets/icons/types';

import { words } from '../../../../../../../locales/keys';

interface ThreeDStockSubHeaderSelectedButtonProps {
  selectedItemsCount?: number;
  onSelectedItemsSidebarOpen?: () => void;
}

function ThreeDStockSubHeaderSelectedButton({
  onSelectedItemsSidebarOpen,
  selectedItemsCount = 0
}: ThreeDStockSubHeaderSelectedButtonProps) {
  const buttonRef = useRef<HTMLButtonElement>();

  const prevSelectedItemsCount = usePreviousValue(selectedItemsCount);

  useEffect(() => {
    if (buttonRef.current && selectedItemsCount > prevSelectedItemsCount) {
      buttonRef.current.classList.add('ping-effect');

      setTimeout(() => {
        buttonRef.current?.classList.remove('ping-effect');
      }, 500);
    }
  }, [prevSelectedItemsCount, selectedItemsCount]);

  return (
    <RefButtonHelper
      className="py-1.5 pl-1.5 pr-3 space-x-1 rounded-md inline-flex items-center whitespace-nowrap text-sm font-medium leading-5 focus:ring-base hover:text-gray-950 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 focus:ring-offset-0 transition-colors duration-150 ease-out"
      onClick={onSelectedItemsSidebarOpen}
      dataGa="open-button-selected-products-sidebar"
      ref={buttonRef}
    >
      <Icon icon={IconsEnum.CHECK} className="h-4 w-4" />

      <span>
        <Translate id={words.selected} />
      </span>
      <span
        className={
          selectedItemsCount
            ? 'min-w-5 h-5 px-1 rounded-full bg-blue-500 text-white leading-5 text-sm relative -right-0.5'
            : 'hidden'
        }
      >
        {selectedItemsCount}
      </span>
    </RefButtonHelper>
  );
}

export default ThreeDStockSubHeaderSelectedButton;
